import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import useReactHookForm from "hooks/useReactHookForm";
import { makeStyles } from "@mui/styles";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { useHistory, useLocation, useRouteMatch } from "react-router";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import LibraryService from "pages/build-test/service";
import { ResponseGenerator } from "interfaces";
import { storeDeliveryList } from "pages/build-test/slices/validate-test-id";
import {
  createDeliveryTestTitle,
  createDeliveryTitle,
  createDeliveryValidationSchema,
} from "pages/build-test/routes/delivery/helpers";
import {
  createBuildTestProperties,
  deliveryListMetakey,
  getSelectedStates,
  getSelectedYear,
  mandatoryFields,createDeliveryProperties,createDeliveryInitialValues,
} from "./helper";
import DeliveryForm from "./delivery-form";
import { useLazyQuery } from "@apollo/client";
import { GET_EXAM_SCHEDULE_ID } from "utils/graphql/services/exam-schedule/queries";
import myClassroomClient from "utils/graphql/myclassroom";
import { isEmpty } from "utils/helpers";
import buildTestServices from "pages/build-test/service";
import { metadataSuccess } from "app-component/slices/metadata-slice";

const useStyles = makeStyles({
  padding: {
    "& .css-1oqqzyl-MuiContainer-root ": {
      padding: 0,
    },
  },
});

export default function CreateDeliveryForm() {
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const history = useHistory();
  const { loading } = useAppSelector((state) => state.createBuildDelivery);
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    createDeliveryInitialValues,
    createDeliveryValidationSchema,
    ""
  );
  const [validateDelivery, setValidDelivery] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [testType, setTestType] = useState("");
  const search = useLocation().search;
  const testId = new URLSearchParams(search).get("testId");
  const testName = new URLSearchParams(search).get("testName");
  const hasTestDetails = testId && testName;
  const match: any = useRouteMatch();
  const { isLoading, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );

  const [getExamById, { loading: loadingUp, error: errorUp, data: dataSch }] =
    useLazyQuery(GET_EXAM_SCHEDULE_ID, {
      client: myClassroomClient,
      fetchPolicy: "no-cache",
    });

  const updateMetaData = async (listData, metaKey, listData2, metaKey2) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    metadataList[metaKey2] = listData2;
    await dispatch(metadataSuccess(metadataList));
  };

  useEffect(() => {
    if (
      watch().warm_up_delivery_id != "" &&
      watch().warm_up_delivery_id != null
    ) {
      const res: any = LibraryService.getValidateWarmUp({
        warm_up_delivery_id: watch().warm_up_delivery_id,
      });

      res.then((response) => {
        if (response.data.data.is_valid_delivery) {
          setValidDelivery(response.data.data.is_valid_delivery);
          dispatch(snackbarRequest({ message: "Warm Up Id is Valid" }));
        } else {
          setValidDelivery(response.data.data.is_valid_delivery);
          dispatch(
            snackbarRequest({ message: response.data.message, type: "error" })
          );
        }
      });
    }
  }, [watch().warm_up_delivery_id]);

  const handleSetDeliveryJumbleAndAttendanceStatus = (testType: string) => {
    if (testType === "Scheduled Tests" || testType === "") {
      setValue("is_jumble", "");
      setValue("attendance", "");
    } else {
      setValue("is_jumble", "Lf37ipufz5");
      setValue("attendance", "Yes");
    }
  };

  useEffect(() => {
    if (watch().test_id != "" && watch().test_id != null) {
      const res: any = LibraryService.validateTestId({
        test_id: watch().test_id,
      });
      res.then((response) => {
        if (response.status === 200 && response.data.status == "success") {
          setValue("label", response.data.data.test_name);
          setValue("test_type", response.data.data.exam_category);
          setTestType(response.data.data.exam_category);
          handleSetDeliveryJumbleAndAttendanceStatus(
            response.data.data.exam_category
          );
          dispatch(storeDeliveryList(response?.data?.data));
        } else {
          setValue("label", "");
          setValue("test_type", "");
          setTestType("");
          handleSetDeliveryJumbleAndAttendanceStatus("");
          dispatch(
            snackbarRequest({ message: response.data.message, type: "error" })
          );
        }
      });
    }
  }, [watch().test_id]);

  useEffect(() => {
    if (hasTestDetails) {
      setValue("test_name", testName);
      setValue("test_id", testId);
    }
  }, [hasTestDetails]);

  const handleSubmit = async () => {
    setIsCreating(true);
    const values = watch();
    const {
      test_id,
      label,
      is_jumble,
      attendance,
      academic_year_id,
      state_id,
      district_object_id,
      college_id,
      reservation_status_id,
      class_id,
      batch_id,
      sub_batch_id,
      start_date_time,
      end_date_time,
      delivery_type_object_id,
      board_id,
      ntse_exam_object_id,
      cnaps_level_list,
      warm_up_delivery_id,
      show_results,
      show_response_sheet,
      show_revise_now,
    } = values;

    const reqBody: any = {
      test_id: test_id,
      schedule_exam_delivery_id: match?.params?.schdule_id,
      label: label,
      jumble_status_object_id: is_jumble,
      attendance_object_id: attendance,
      academic_year_list: academic_year_id,
      state_list: state_id,
      district_list: district_object_id,
      college_list: college_id,
      reservation_status_list: reservation_status_id,
      class_list: class_id,
      batch_list: batch_id,
      sub_batch_list: sub_batch_id,
      start_date_time: start_date_time,
      end_date_time: end_date_time,
      delivery_type_object_id: delivery_type_object_id,
      board_list: board_id,
      ntse_exam_object_id: ntse_exam_object_id,
      cnaps_level_list: cnaps_level_list,
      warm_up_delivery_id: warm_up_delivery_id,
      show_results: show_results == "true" ? true : false,
      show_response_sheet: show_response_sheet == "true" ? true : false,
      show_revise_now: show_revise_now == "true" ? true : false,
    };

    if (reqBody.warm_up_delivery_id != "") {
      if (validateDelivery) {
        // dispatch(createBuildDeliveryRequest(reqBody));
        const res: ResponseGenerator =
          await buildTestServices.createBuildDeliveryApi(reqBody);
        if (res.status === 200 && res.data.status === "success") {
          dispatch(
            snackbarRequest({
              message: res?.data?.message || "Delivery created successfully",
            })
          );
          history.replace(
            `/exam_schedule/delivery_list/${match?.params?.schdule_id}`
          );
        } else {
          dispatch(
            snackbarRequest({ message: res.data.message, type: "error" })
          );
        }
      } else {
        dispatch(
          snackbarRequest({
            message: "Please enter valid Warm up id",
            type: "error",
          })
        );
      }
    } else {
      const res: ResponseGenerator =
        await buildTestServices.createBuildDeliveryApi(reqBody);
      if (res.status === 200 && res.data.status === "success") {
        dispatch(
          snackbarRequest({
            message: res?.data?.message || "Delivery created successfully",
          })
        );
        history.replace(
          `/exam_schedule/delivery_list/${match?.params?.schdule_id}`
        );
      } else {
        dispatch(snackbarRequest({ message: res.data.message, type: "error" }));
      }
    }
    setIsCreating(false);
  };

  useEffect(() => {
    if (!isEmpty(dataSch?.getExamSchedule)) {
      const { getExamSchedule } = dataSch;
      setValue("start_date_time", new Date(getExamSchedule.scheduled_date));
      setValue("academic_year_id", getExamSchedule.academic_year_ids);
      setValue("state_id", getExamSchedule.state_ids);
      setValue("college_id", getExamSchedule.college_ids);
      setValue("board_id", getExamSchedule.board_ids);
      setValue("class_id", getExamSchedule.class_ids);
      setValue("batch_id", getExamSchedule.batch_ids);

      updateMetaData(
        metaData?.state_list,
        deliveryListMetakey?.state,
        metaData?.academic_year_list,
        deliveryListMetakey?.year
      );
    }
  }, [dataSch]);

  useEffect(() => {
    getExamById({
      variables: {
        id: match?.params?.schdule_id,
      },
    });
  }, []);

  return (
    <Box className={classes.padding}>
      <DeliveryForm
        control={control}
        errors={errors}
        getValues={getValues}
        setValue={setValue}
        watch={watch}
        headerFields={
          hasTestDetails ? createDeliveryTestTitle : createDeliveryTitle
        }
        mainFields={createDeliveryProperties(testType || "")}
        detailsFields={createBuildTestProperties}
        handleSubmit={handleSubmit}
        title="Create Delivery"
        buttonValue="Add Delivery"
        isLoading={isCreating}
        mandatoryFields={mandatoryFields(testType || "")}
        dataSch={dataSch}
      />
    </Box>
  );
}
